
<div class="row">
  <div class="col-12 image-container">
    <img class="final-image" src="paybee-spa/assets/images/png/signup-success-illustration.png">
  </div>
</div>

<div class="row">
  <div class="col-12 text-container">
    Your Account has been successfully created! Click below to go to your dashboard.
    <ng-container *ngIf="invoices$ | async as invoices">
      <div *ngIf="invoices.length > 0"> Invoice of {{ invoices[0].amount | currency:'USD':'symbol-narrow':'1.0-0' }} has been created, pay on the next screen.</div>
    </ng-container>
  </div>
</div>

<div class="row justify-content-center">
  <div class="col-12 col-sm-6 col-lg-4">
    <button class="action-button btn btn--paybee btn--black w-100" (click)="goToDashboard()"> Go to Dashboard </button>
  </div>
</div>

